var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99999 10.6667C4.89542 10.6667 3.99999 11.5621 3.99999 12.6667C3.99999 13.0349 4.29847 13.3333 4.66666 13.3333H11.3333C11.7015 13.3333 12 13.0349 12 12.6667C12 11.5621 11.1046 10.6667 9.99999 10.6667H5.99999ZM2.66666 12.6667C2.66666 10.8257 4.15904 9.33333 5.99999 9.33333H9.99999C11.8409 9.33333 13.3333 10.8257 13.3333 12.6667C13.3333 13.7712 12.4379 14.6667 11.3333 14.6667H4.66666C3.56209 14.6667 2.66666 13.7712 2.66666 12.6667Z",
    fill: "#714FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99999 2.66667C6.89542 2.66667 5.99999 3.5621 5.99999 4.66667C5.99999 5.77123 6.89542 6.66667 7.99999 6.66667C9.10456 6.66667 9.99999 5.77123 9.99999 4.66667C9.99999 3.5621 9.10456 2.66667 7.99999 2.66667ZM4.66666 4.66667C4.66666 2.82572 6.15904 1.33333 7.99999 1.33333C9.84094 1.33333 11.3333 2.82572 11.3333 4.66667C11.3333 6.50761 9.84094 8 7.99999 8C6.15904 8 4.66666 6.50761 4.66666 4.66667Z",
    fill: "#714FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/UserIcon.ea37c8ba3f582b667a1be22825d3d464.svg";
export { ForwardRef as ReactComponent };